const menuBlock = document.querySelector(".mobile-menu");
const menuBtn = document.querySelector(".menu_link_button");
const menuFirstChildBlock = document.querySelector(".mobile_menu_item_children");
const menuBackBtn = document.querySelector(".arrow_btn");
const menuSubBlock = document.querySelectorAll(".menu_items_child");

menuBlock.addEventListener('click', function(e){
  const clicked = e.target.closest(".menu-item-has-children");
  if(!clicked) return;
  menuFirstChildBlock.classList.add('mobile_menu_item_children--active');
  menuBackBtn.classList.add("arrow_btn--active");
  menuSubBlock.forEach( sb => sb.classList.remove("menu_items_child--active") );
  document.querySelector(`.menu-item--${clicked.dataset.tab}`).classList.add("menu_items_child--active");
});

menuBackBtn.addEventListener('click', function(){
  menuFirstChildBlock.classList.remove('mobile_menu_item_children--active');
  menuBackBtn.classList.remove("arrow_btn--active");
});



